import * as firebaseConfigJson from "./firebaseConfig.json";
import * as emulJson from "./use_emulator.json";

const firebaseConfigs = firebaseConfigJson;
const emulConfig = emulJson;

export const firebaseConfig = {
    apiKey: firebaseConfigs.apiKey,
    authDomain: firebaseConfigs.authDomain,
    projectId: firebaseConfigs.projectId,
    storageBucket: firebaseConfigs.storageBucket,
    messagingSenderId: firebaseConfigs.messagingSenderId,
    appId: firebaseConfigs.appId,
    region: firebaseConfigs.region,
};
export const useEmulator = emulConfig.useEmulator;
